<script setup lang="ts">
import { useSdk } from '~/sdk';
import { useStorage } from '@vueuse/core';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const { locale } = useI18n();
const isOpen = useStorage('popup-state', () => true, sessionStorage);

const { data } = useAsyncData(`popup-data-${locale.value}`, async () => {
  return await useSdk().cms.getContent({
    entries: null,
    globalSet: {
      handle: 'popup',
      fragment: `
        name
        ... on popup_GlobalSet {
          popup {
            ... on feature_Entry {
              heading: featureHeading
              body: featureBody {
                html
                rawHtml
                markdown
                plainText
              }
              images {
                id
                url
              }
            }
          }
        }
      `,
    },
  });
});

const popup = computed(() => data.value?.popup[0] ?? null);
</script>

<template>
  <Dialog v-model:open="isOpen" v-if="popup">
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{{ popup.heading }}</DialogTitle>
      </DialogHeader>
      <div class="prose max-w-none" v-html="popup.body?.html"></div>
      <DialogClose as-child>
        <Button type="button" variant="secondary">
          {{ $t('Ok') }}
        </Button>
      </DialogClose>
    </DialogContent>
  </Dialog>
</template>
